import { useState, useEffect } from "react"
import { Container, Typography } from "@mui/material"
import { Wrapper, OTPwrapper, Input, ResendCode } from '../style'
import toEnglishDigits from '../../../functions/toEnglishDigits'
import { useLocation, useNavigate } from "react-router-dom"
import verifySchema from '../../../validation/verify'
import validate from "../../../validation"
import LoadingButton from '@mui/lab/LoadingButton';
import axios from 'axios'
import { baseURL } from "../../../functions/baseUrl"
import { useTranslation } from 'react-i18next';

export default function Verify () {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'auth' });

  const [count, setCount] = useState(120)
  useEffect(() => {
    if (count > 0) {
      setTimeout(() => {
        setCount(count - 1)
      }, 1000)
    }
  }, [count])

  const location = useLocation()
  const navigate = useNavigate()

  const [value, setValue] = useState('');

  function handleChange(event) {
    const newValue = event.target.value
    if (newValue.match(/^[0-9۰-۹]*$/) && newValue.length <= 6) {
      setValue(toEnglishDigits(newValue));
    }
  }

  const inputfocus = (elmnt) => {
    // if (elmnt.key.match(/^[0-9۰-۹]$/)) {
    //   setValue(toEnglishDigits(value + elmnt.key));
    // }

    if (elmnt.key === "Enter" && value.length === 6) {
      handleRequest()
    }
  }

  const [error, setError] = useState({})
  const validationData = () => {
    const params = {
      otp: value
    }
    const constrains = verifySchema()

    const hasError = false
    let err = {}
    const keys = Object.keys(params)
    for (let i = 0; i < keys.length; i++) {
      const errorMessage = validate(params, keys[i], constrains)
      err = { ...err, [keys[i]]: errorMessage }
      if (errorMessage) {
        setError({ ...err })
        return true
      }
    }
    setError({ ...err })
    return hasError
  }

  const [loading, setLoading] = useState(false)
  const handleRequest = () => {
    setLoading(true)
    axios.post(baseURL + '/auth/', {
      mobile_number: location.state?.mobile,
      otp: value
    })
    .then((response) => {
      window.localStorage.setItem('user', JSON.stringify(response.data.user))

      const destination = location.state?.next || '/'
      navigate(destination, {replace: true})
    })
    .catch((error) => {
      setLoading(false)
      if (error?.response?.status === 429) {
        setError({otp: 'خطای درخواست زیاد، لطفا چند دقیقه بعد تلاش کنید.'})
      } else {
        setError({otp: error?.response?.data?.detail || t('server_error')})
      }
    });
  }

  function handleClick () {
    const hasError = validationData()
    if (!hasError) {
      // empty error object
      setError({})
      // submit data
      handleRequest()
    }
  }

  useEffect(() => {
    if (value.length === 6 && !loading) {
      setLoading(true)
      handleRequest()
    }
  }, [value])

  const resendCode = () => {
    setCount(120)
    axios.post(baseURL + '/otp/', {
      mobile_number: location.state?.mobile
    })
    .then(() => {
      // do nothing
    })
    .catch((error) => {
      console.log(error)
    });
  }

  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  return (
    <Container maxWidth='xs' dir={direction}>
      <Wrapper>
        <Typography variant="h6" component="h6" align="center">
          {t('verify_mobile_number')}
        </Typography>
        <Typography variant="caption" component="span" align="center">
          {t('verification_sms_sent', {mobile: location.state?.mobile})}
        </Typography>
        <OTPwrapper
          autoComplete={false}
        >
          <Input
            name="otp"
            maxLength="6"
            value={value}
            onChange={handleChange}
            onKeyUp={(e) => inputfocus(e)}
            autoFocus
            autoComplete={false}
            pattern="[0-9۰-۹]*"
            inputmode="numeric"
            type="number"
            error={error.otp}
          />
        </OTPwrapper>
        {!!error.otp &&
          <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
            {error.otp}
          </Typography>
        }
        {count > 1
          ? <ResendCode>{count} {t('time_to_resend_code')} </ResendCode>
          : <ResendCode onClick={resendCode} className="clickable">{t('resend_code')} </ResendCode>
        }

        <LoadingButton
          variant="contained"
          onClick={handleClick}
          loading={loading}
          disabled={loading}
          loadingPosition="start"
        >
          {t('login')}
        </LoadingButton>
        <Typography
          variant="caption"
          component="span"
          align="center"
          sx={{
            cursor: 'pointer'
          }}
          onClick={() => navigate(-1)}
        >
          {t('click_for_changing_mobile')}
        </Typography>
      </Wrapper>
    </Container>
  )

}
